import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "../../../services/ApiService";
import { useAppContext } from "../../../context/AppContext";
import Swal from "sweetalert2";
import { fixImageOrientation } from "../../../utils/fixImageOrientation";
import { Link } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";
import SectionLoader from "../../../components/SectionLoader";
import BackButton from '../../../components/BackButton';
import { getOrCreateDeviceId } from "../../../utils/deviceId";

const UploadDumpMatericalPhoto: React.FC = () => {
  const navigate = useNavigate();
  const deliveryID = localStorage.getItem("delivery_id");
  const [userSelected, setUserSelected] = useState(false);

  const vendor_id = localStorage.getItem("vendor_id");
  const sales_order_id = localStorage.getItem("sales_order_id");
  const api_token = localStorage.getItem("_token");
  const { 
    purchaseOrder, 
    delivery, 
    photos, 
    setPhotos,
    setPurchaseOrder,
    setToken,
    setDelivery,
    setSalesOrder,
    setLoads,
    setAttachments,
    setLoadItems,
    setMeterialSo,
    setMaterialfo,
    setProgressDeliveries,
  } = useAppContext();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // Fresh data fetch on load
  useEffect(() => {
    const fetchFreshData = async () => {
      if (!api_token || !sales_order_id) {
        setIsLoading(false);
        return;
      }

      if (delivery && delivery.id && delivery.status) {
        // Validate delivery status - should be 'reached' for dump material page
        if (delivery.status !== 'reached' && delivery.status !== 'completed') {
          if (delivery.status === 'picked_up') {
            navigate('/upload-weight-ticket');
          } else if (delivery.status === 'assigned') {
            navigate('/pick-up');
          } else if (delivery.status === 'open') {
            navigate('/');
          }
          setIsLoading(false);
          return;
        }
        setIsLoading(false);
        return;
      }

      if (vendor_id && sales_order_id) {
        try {
          const deviceId = getOrCreateDeviceId();
          const responseData = await ApiService.getFreshData({
            vendor_id: vendor_id,
            sales_order_id: sales_order_id,
            delivery_id: deliveryID || null,
            token: false,
            device_id: deviceId,
          });

          if (responseData && responseData.success) {
            setPurchaseOrder(responseData.data.purchase_order);
            setToken(responseData.api_token);
            setDelivery(responseData.data.delivery);
            setLoads(responseData.data.loads);
            setLoadItems(responseData.data.item_loads);
            setPhotos(responseData.data.photos || []);
            setAttachments(responseData.data.attachments || []);
            setSalesOrder(responseData.data.sales_order);
            setMeterialSo(responseData.data.meterial_so);
            setMaterialfo(responseData.data.material_fo);
            setProgressDeliveries(responseData.data.progress);

            if (responseData.data.delivery) {
              const deliveryStatus = responseData.data.delivery.status;
              if (deliveryStatus !== 'reached' && deliveryStatus !== 'completed') {
                if (deliveryStatus === 'picked_up') {
                  navigate('/upload-weight-ticket');
                } else if (deliveryStatus === 'assigned') {
                  navigate('/pick-up');
                } else if (deliveryStatus === 'open') {
                  navigate('/');
                }
              }
            }
          }
        } catch (error: any) {
          console.error("Error fetching fresh data:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchFreshData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api_token, vendor_id, sales_order_id]);

  const [file, setFile] = useState<string | undefined>(undefined);
  const [isfileUploaded, setIsFileUploaded] = useState<boolean>(false);
  const [getFileForApi, setGetFileForApi] = useState<File | null>(null);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);

  // useEffect(() => {
  //   let OldDumpMaterialPhoto = [];
  //   if (photos && Array.isArray(photos)) {
  //     OldDumpMaterialPhoto = photos.filter(
  //       (field: any) => field.photo_type === "dump_material" && field.delivery_id === delivery.id
  //     );
  //   }
    
    
  //   if (OldDumpMaterialPhoto.length !== 0 && OldDumpMaterialPhoto[0].file_url && OldDumpMaterialPhoto[0].file_url !== null) {
  //     console.log("OldDumpMaterialPhoto", OldDumpMaterialPhoto);
  //     setFile(OldDumpMaterialPhoto[0].file_url);
  //     setIsFileUploaded(true);
  //   } else {
  //     setIsFileUploaded(false);
  //     setFile(undefined);
  //   }
  // }, [photos]);
  

useEffect(() => {
  if (userSelected) return; // ✅ don't override new preview

  let OldDumpMaterialPhoto = [];
  if (photos && Array.isArray(photos)) {
    OldDumpMaterialPhoto = photos.filter(
      (field: any) => field.photo_type === "dump_material" && field.delivery_id === delivery.id
    );
  }

  if (OldDumpMaterialPhoto.length !== 0 && OldDumpMaterialPhoto[0].file_url) {
    setFile(OldDumpMaterialPhoto[0].file_url);
    setIsFileUploaded(true);
  } else {
    setIsFileUploaded(false);
    setFile(undefined);
  }
}, [photos, userSelected, delivery?.id]);


  if (isLoading || !purchaseOrder) return <SectionLoader />;

  // function getFile(event: React.ChangeEvent<HTMLInputElement>) {
  //   let uploadedFile = event.target.files?.[0];
  //   setGetFileForApi(uploadedFile || null);
  //   if (uploadedFile) {
  //       const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setFile(reader.result as string);
  //     };
  //     if (uploadedFile) {
  //       reader.readAsDataURL(uploadedFile);
  //     }
  //     // setFile(URL.createObjectURL(uploadedFile));
  //   }
  // }
 

// function getFile(event: React.ChangeEvent<HTMLInputElement>) {
//   const uploadedFile = event.target.files?.[0];
//   if (!uploadedFile) return;

//   setGetFileForApi(uploadedFile);
 
//   const previewURL = URL.createObjectURL(uploadedFile);
//   setFile(previewURL);
 
//   return () => URL.revokeObjectURL(previewURL);
// }

async function getFile(event: React.ChangeEvent<HTMLInputElement>) {
  let uploadedFile = event.target.files?.[0];
  if (!uploadedFile) return;

  uploadedFile = await fixImageOrientation(uploadedFile);
  setUserSelected(true);
  setGetFileForApi(uploadedFile);

  const reader = new FileReader();
  reader.onloadend = () => {
    setFile(reader.result as string);
  };
  reader.readAsDataURL(uploadedFile);
}


  const SubmitFileUploadTicket = async () => {
    setButtonLoading(true);
    
    if (!getFileForApi) {
      Swal.fire({
        title: "Error",
        text: "Please upload dump material Photo.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setButtonLoading(false);
      return;
    }

    // File validation
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif'];
    if (!allowedTypes.includes(getFileForApi.type)) {
      Swal.fire({
        title: "Error",
        text: "Invalid file type. Please upload an image file (JPEG, PNG, WebP, or GIF).",
        icon: "error",
        confirmButtonText: "OK",
      });
      setButtonLoading(false);
      return;
    }

    // Validate file size (max 10MB)
    const maxSize = 10 * 1024 * 1024;
    if (getFileForApi.size > maxSize) {
      Swal.fire({
        title: "Error",
        text: "File size too large. Please upload a file smaller than 10MB.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setButtonLoading(false);
      return;
    }

    // Validate delivery status
    if (delivery && delivery.status && delivery.status !== 'reached') {
      Swal.fire({
        title: "Error",
        text: `Cannot upload dump material photo. Delivery status is "${delivery.status}". Expected "reached".`,
        icon: "error",
        confirmButtonText: "OK",
      });
      setButtonLoading(false);
      return;
    }

    // Use delivery from context or fallback to localStorage
    const currentDeliveryId = delivery?.id || deliveryID;
    if (!currentDeliveryId) {
      Swal.fire({
        title: "Error",
        text: "Delivery ID not found. Please refresh the page.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setButtonLoading(false);
      return;
    }

    const vendor_id = localStorage.getItem("vendor_id");
    const formData = new FormData();
    formData.append("delivery_id", currentDeliveryId);
    formData.append("file", getFileForApi);
    formData.append("photo_type", "dump_material");
    if (vendor_id) {
      formData.append("vendor_id", vendor_id);
    }
    
    let responseData = null;

    try {
      responseData = await ApiService.uploadFile(formData);
      if (responseData && responseData.success) {
        setButtonLoading(false);
        setPhotos(responseData.data);
        Swal.fire({
          title: "Success",
          text: "Photo uploaded successfully.",
          icon: "success",
          confirmButtonText: "Next",
        }).then(() => {
          // navigate("/proof-of-dumping");
          localStorage.setItem('page','digital-signature');
           navigate("/digital-signature");
        });
      }
    } catch (error: any) {
      console.error("Error uploading Your Photo:", error);
      setButtonLoading(false);
      Swal.fire({
        title: "Error",
        text:
          error instanceof Error ? error.message : "An unknown error occurred.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }
 
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <Sidebar />

        <div className="col-lg-9 col-12 content-area"> 
          <div className="row">
            <div className="col-12 mb-2 mt-2">
              <BackButton />
            </div>
            <div className="col-12 mb-2">
              <div className="box py-1 px-3">
                <h5 className="mb-0 text-center fw-semibold">
                  Take a photo of the dumped material on the ground.
                </h5>
              </div>
            </div>
            <div className="col-md-12 m-auto mb-4">
              <div
                style={file ? { backgroundImage: `url(${file})` } : {}}
                className="image-box"
              >
                <label htmlFor="fileUpload" className="custom-file-upload">
                  Take Photo Or Upload File
                  <i className="bi bi-camera secondary-text m-auto"></i>
                </label>
                <input
  id="fileUpload"
  accept="image/*"
  onChange={getFile}
  name="weight_ticket"
  type="file"
/>

              </div>
              {!isfileUploaded && (
                <h6 className="note text-center mt-3">
                  (If you <Link className="secondary-text" to="/dump-site-photo-reason"> skip </Link> it then please Provide a valid reason)
                </h6>
              )}
            </div>
          </div>

          <div className="mt-1 d-flex row m-auto flex-wrap align-items-center justify-content-center gap-3">
            <div className="col-md-6 col-12">
              {file && (
              <button
                disabled={buttonLoading}
                onClick={SubmitFileUploadTicket}
                className="btn-orange w-100"
              >
                {buttonLoading && (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
                {isfileUploaded ? "Re-Upload" : "Upload"}
              </button>
              )}
            </div>
            <div className="col-md-6 col-12">
              {!isfileUploaded && (
                <Link to="/dump-site-photo-reason" className="btn-light-orange w-100 text-center d-block">
                  Skip For Now
                </Link>
              )}
              {isfileUploaded && (
                <Link to="/digital-signature" className="btn-light-orange w-100 text-center d-block">
                  Next
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UploadDumpMatericalPhoto;
